import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { loading, alert, toFixed, format_date, getStorage, replaceText } from "./CustomComponent.js";

import "../assets/css/bootstrap.css";
import "./global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// ใบแจ้งหนี้ตามอาคาร
async function report_billing(data, current_month, last_month) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  // จัดกลุ่มข้อมูลตามอาคารรอบเดียว (O(N)) เร็วกว่าการใช้ filter ซ้อน map มาก
  const groupedByBuilding = data.reduce((acc, item) => {
    let bd = item.building || "-";
    if (!acc[bd]) acc[bd] = [];
    acc[bd].push(item);
    return acc;
  }, {});

  const buildingKeys = Object.keys(groupedByBuilding);
  
  let text_array = buildingKeys.map((bd, bd_index) => {
    const tableBody = groupedByBuilding[bd].map((item) => {
      let other = (item.other_income || 0) + (item.fire_cost || 0) + (item.cable_cost || 0);
      let debt = (item.add_debt || 0) - (item.reduce_debt || 0);
      let totalAmt = (item.total_amount || 0) + (item.overdue_amount || 0);

      return [
        item.address_number || "-",
        { text: item.current_gauge_number || "0", alignment: "center" },
        { text: item.last_gauge_number || "0", alignment: "center" },
        { text: Number(item.unit_used || 0), alignment: "center" },
        { text: toFixed(item.water_bill || 0), alignment: "right" },
        { text: toFixed(item.equipment_maintenance_fee || 0), alignment: "right" },
        { text: toFixed(item.common_expenses || 0), alignment: "right" },
        { text: toFixed(item.waste_cost || 0), alignment: "right" },
        { text: toFixed(other), alignment: "right" },
        { text: item.count_installment || "0", alignment: "center" },
        { text: toFixed(item.overdue_amount || 0), alignment: "right" },
        { text: toFixed(debt), alignment: "right" },
        { text: toFixed(item.meter_connect_cost_all ?? item.meter_connect_cost ?? 0), alignment: "right" },
        { text: toFixed(item.total_cost_late_all ?? item.total_cost_late ?? 0), alignment: "right" },
        { text: toFixed(totalAmt), alignment: "right" },
      ];
    });

    return [
      {
        columns: [
          { text: getStorage("project_name") || "", alignment: "left", fontSize: 14, bold: true },
          { text: `ค่าน้ำ ค่าส่วนกลางและอื่นๆประจำเดือน ${format_date(new Date(), "MMMM")} พ.ศ. ${format_date(new Date(), "YYYY")}`, alignment: "right", fontSize: 14, bold: true },
        ],
      },
      {
        columns: [
          { text: `รายงานแจ้งหนี้ค่าใช้จ่ายส่วนกลาง อาคาร ${bd}`, alignment: "left", fontSize: 18, bold: true },
          { text: `พิมพ์ ณ. วันที่ ${format_date(new Date(), "DD MMMM YYYY")}`, alignment: "right", fontSize: 14, bold: true },
        ],
      },
      {
        table: {
          headerRows: 1,
          widths: ["6.60%", "6.00%", "6.00%", "5.65%", "6.45%", "7.20%", "6.70%", "6.20%", "7.70%", "3.00%", "8.40%", "7.25%", "5.75%", "7.50%", "9.60%"],
          body: [
            [
              { text: "บ้านเลขที่", alignment: "center" }, { text: `เลขมาตร ${current_month}`, alignment: "center" },
              { text: `เลขมาตร ${last_month}`, alignment: "center" }, { text: "จำนวน หน่วยใช้", alignment: "center" },
              { text: "ค่าน้ำ ประปา", alignment: "center" }, { text: "ค่าบริการ อุปกรณ์", alignment: "center" },
              { text: "ค่าส่วน กลาง", alignment: "center" }, { text: "ค่าขยะ", alignment: "center" },
              { text: "รายรับ อื่นๆ", alignment: "center" }, { text: "งวด", alignment: "center" },
              { text: "จำนวนเงิน ค้างชำระ", alignment: "center" }, { text: "เพิ่ม/ลดหนี้", alignment: "center" },
              { text: "ค่าต่อ มิเตอร์", alignment: "center" }, { text: "เบี้ยปรับ", alignment: "center" },
              { text: "รวมทั้งสิ้น", alignment: "center" },
            ],
            ...tableBody,
          ],
        },
        pageBreak: bd_index === buildingKeys.length - 1 ? "" : "after",
      },
    ];
  });

  const docDefinition = {
    content: text_array,
    defaultStyle: { font: "THSarabunNew", fontSize: 10 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  open(textDocDefinition, `รายงานแจ้งหนี้ค่าใช้จ่ายส่วนกลาง ${new Date().toISOString()}.pdf`);
}

export { report_billing };